import { getUserCookie } from "./cookies";

const DISPLAY_NAME_KEY = "user_display_name";
const EMPLOYEE_ID_KEY = "user_employee_id";

const pickDisplayName = (user) => {
  if (!user || typeof user !== "object") return "";
  const joined = [user.firstName, user.lastName]
    .filter(Boolean)
    .join(" ")
    .trim();
  return user.userName || user.fullName || user.name || joined || "";
};

const looksLikeEmail = (value) =>
  typeof value === "string" && /^\S+@\S+\.\S+$/.test(value.trim());

const pickEmployeeId = (user) => {
  if (!user || typeof user !== "object") return "";
  const raw =
    user.staffId ??
    user.employeeCode ??
    user.employeeId ??
    user.staffCode ??
    "";
  return raw === "" || raw == null ? "" : String(raw);
};

const HOSPITAL_NAME_KEY = "user_hospital_name";
const HOSPITAL_LOGO_KEY = "user_hospital_logo";

export const persistUserProfile = (user) => {
  const name = pickDisplayName(user);
  if (name) localStorage.setItem(DISPLAY_NAME_KEY, name);

  const emp = pickEmployeeId(user);
  if (emp) localStorage.setItem(EMPLOYEE_ID_KEY, emp);

  const hosp = user?.hospital?.name || user?.hospitalName || "";
  if (hosp) localStorage.setItem(HOSPITAL_NAME_KEY, hosp);

  const logo =
    user?.hospital?.logo ||
    user?.hospital?.logoUrl ||
    user?.hospital?.hospitalLogo ||
    user?.hospitalLogo ||
    "";
  if (logo) localStorage.setItem(HOSPITAL_LOGO_KEY, logo);

  const facilityKind = String(user?.facilityKind || "")
    .trim()
    .toLowerCase();
  if (facilityKind === "hospital" || facilityKind === "yoga_studio") {
    localStorage.setItem("facility_kind", facilityKind);
  }
};

export const getProfileHeaderName = () => {
  const stored = localStorage.getItem(DISPLAY_NAME_KEY);
  if (!stored || looksLikeEmail(stored)) return "User";
  return stored;
};

export const getProfileEmployeeId = () => {
  const stored = localStorage.getItem(EMPLOYEE_ID_KEY);
  if (stored) return stored;
  return getUserCookie("STAFF_ID") || "";
};

export const getProfileHospitalName = () => {
  return localStorage.getItem(HOSPITAL_NAME_KEY) || "";
};

export const getProfileHospitalLogo = () => {
  return localStorage.getItem(HOSPITAL_LOGO_KEY) || "";
};
